import { ChangeDetectionStrategy, Component, inject, Input, OnInit, signal } from '@angular/core';
import { Newsletter, NewsletterDto } from '@components/newsletter/model';
import { NewsletterService } from '@components/newsletter/services';
import { LogsService } from '@services/logs';
import { ButtonComponent } from '@shared/components/button';
import { FormItemComponent } from '@shared/components/form-item';
import { FormAbstractComponent } from '@shared/components/form-item/abstract';
import { FormItem } from '@shared/components/form-item/model';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { take } from 'rxjs';

@Component({
  selector: 'app-newsletter',
  imports: [ButtonComponent, TitleComponent, FormItemComponent],
  templateUrl: './newsletter.component.html',
  styleUrl: './newsletter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewsletterComponent extends FormAbstractComponent implements OnInit {
  @Input() data!: Newsletter;
  dataDynamic = signal<Newsletter>(null!);
  isSuccess = signal(false);
  isSending = signal(false);
  title = signal<Title>(null!);
  specification = signal<{ [key: string]: FormItem }>(null!);

  readonly #newsletterService = inject(NewsletterService);
  readonly #logsService = inject(LogsService);

  ngOnInit(): void {
    this.dataDynamic.set(this.data);
    this.title.set({
      size: {
        desktop: 'H2',
        mobile: 'H3',
      },
      text: this.dataDynamic().title,
      align: {
        mobile: 'LEFT',
        desktop: 'LEFT',
      },
      level: 'SPAN',
      color: 'BLACK',
    });
    this.specification.set({
      email: {
        type: 'TEXT',
        key: 'email',
        rules: {
          textRegex: `^\\w+([\\.-]?\\w+)*@\\w+([\\.-]?\\w+)*(\\.\\w{2,3})+$`,
          tips: `L’adresse email saisie semble mal écrite`,
        },
        placeholder: this.dataDynamic().email,
      },
      consent: {
        type: 'BOOLEAN',
        key: 'optin',
        value: false,
        label: this.dataDynamic().consent,
      },
    });
    this.updateForm({ key: 'email', value: null, isValid: false });
    this.updateForm({ key: 'optin', value: false, isValid: true });
  }

  submit(): void {
    if (!this.isSending()) {
      this.isSending.set(true);
      setTimeout(() => {
        if (this.isValidForm() && this.form['optin']) {
          delete this.form['optin'];
          const data: NewsletterDto = {
            ...(this.form as unknown as NewsletterDto),
            isPro: this.dataDynamic().isPro || false,
          };
          this.#newsletterService
            .create(data, true)
            .pipe(take(1))
            .subscribe({
              next: () => {
                this.isSending.set(false);
                this.isSuccess.set(true);
              },
              error: (err: unknown) => {
                this.isSending.set(false);
                this.#logsService.error('NewsletterComponent', 'Newsletter subscription failed', err);
              },
            });
        } else {
          this.isSending.set(false);
        }
      }, 1000);
    }
  }
}
